module.exports = __webpack_public_path__ + "cb201d4208804904ed3b9c7b75fb47fa.pdf";